import { render, staticRenderFns } from "./ParutionExtrait.vue?vue&type=template&id=3178b0bc&scoped=true&"
import script from "./ParutionExtrait.vue?vue&type=script&lang=js&"
export * from "./ParutionExtrait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178b0bc",
  null
  
)

export default component.exports